export const getIntentTone = (intent) => {
  const i = String(intent || '').toUpperCase();

  // Shape: { bg, text, fill, surface, pillBg }
  // Los colores están alineados al brief: SCALE/efficiency -> teal, COST_CONTROL -> amber, STOP_LOSSES -> rojo, etc.
  if (i === 'COST_CONTROL' || i === 'REALLOCATE_BUDGET' || i === 'RESTORE_PERFORMANCE') {
    return { bg: '#2A1A00', text: '#FCD34D', fill: '#F59E0B', surface: '#FFFBEB', pillBg: '#B45309' };
  }
  if (i === 'STOP_LOSSES') {
    return { bg: '#2A0B0B', text: '#FCA5A5', fill: '#EF4444', surface: '#FFF1F2', pillBg: '#B91C1C' };
  }
  if (i === 'IMPROVE_DELIVERY' || i === 'UNBLOCK_DELIVERY') {
    return { bg: '#0B1B2A', text: '#93C5FD', fill: '#3B82F6', surface: '#EFF6FF', pillBg: '#1D4ED8' };
  }
  if (i === 'CREATIVE' || i === 'IMPROVE_CREATIVE' || i === 'IMPROVE_CONVERSION' || i === 'IMPROVE_CREATIVE_FORMAT' || i === 'REDUCE_SELF_COMPETITION') {
    return { bg: '#160B2A', text: '#C4B5FD', fill: '#8B5CF6', surface: '#F5F3FF', pillBg: '#6D28D9' };
  }
  if (i === 'HYGIENE') {
    return { bg: '#0F172A', text: 'rgba(255,255,255,0.7)', fill: 'rgba(255,255,255,0.35)', surface: '#E2E8F0', pillBg: 'rgba(255,255,255,0.12)' };
  }

  // Default: SCALE / EFFICIENCY / LOWER_CPA / LOWER_CPM
  return { bg: '#06211A', text: '#A7F3D0', fill: '#10B981', surface: '#ECFDF5', pillBg: '#0F6E56' };
};

